"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var frontend_toolkit_1 = require("frontend-toolkit");
var React = require("react");
var form_element_hook_1 = require("./form-element-hook");
var react_hook_form_1 = require("react-hook-form");
var AddMember = require("../../core/gql/mutations/add-member");
var SetFeedbackMessage = require("../../core/gql/mutations/set-feedback-message");
var react_apollo_1 = require("react-apollo");
var CreateElement = form_element_hook_1.default;
var MemberEditForm = function (_a) {
    var appStateStore = _a.appStateStore, orgId = _a.orgId;
    var _b = react_apollo_1.useMutation(AddMember.MUTATION), addMember = _b[0], addMemberResponse = _b[1];
    var setFeedbackMessage = react_apollo_1.useMutation(SetFeedbackMessage.MUTATION)[0];
    var memberForm = react_hook_form_1.useForm();
    // TODO: React to the state of the request
    var isSubmitting = addMemberResponse.loading;
    var handleSubmit = memberForm.handleSubmit, register = memberForm.register;
    return (React.createElement("form", { onSubmit: handleSubmit(function (_a) {
            var firstName = _a.firstName, lastName = _a.lastName, birthdate = _a.birthdate, gender = _a.gender;
            return __awaiter(void 0, void 0, void 0, function () {
                var addMemberResponse_1, e_1;
                var _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, addMember({
                                    variables: {
                                        organizationId: orgId,
                                        firstName: firstName,
                                        lastName: lastName,
                                        birthdate: frontend_toolkit_1.DateService.dateToString(birthdate, frontend_toolkit_1.DateFormat.YYYY_MM_DD),
                                        gender: gender
                                    }
                                })];
                        case 1:
                            addMemberResponse_1 = _d.sent();
                            if ((_c = (_b = addMemberResponse_1 === null || addMemberResponse_1 === void 0 ? void 0 : addMemberResponse_1.data) === null || _b === void 0 ? void 0 : _b.createMember) === null || _c === void 0 ? void 0 : _c.id) {
                                setFeedbackMessage({ variables: {
                                        message: firstName + " " + lastName + " has been added to your organization.",
                                        autoclose: true,
                                        isError: false,
                                    } });
                            }
                            else {
                                setFeedbackMessage({ variables: {
                                        message: "Unable to add " + firstName + " " + lastName + " to your organization.",
                                        autoclose: false,
                                        isError: true,
                                    } });
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _d.sent();
                            setFeedbackMessage({ variables: {
                                    message: "Unable to add " + firstName + " " + lastName + " to your organization.",
                                    autoclose: false,
                                    isError: true,
                                } });
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }) },
        React.createElement("div", { id: "organization-create-editor-content", className: "page-content" },
            React.createElement("h2", { className: "page-content-header" }, "Members / New"),
            React.createElement(teamsnap_ui_1.Panel, { mods: "Panel--form" },
                React.createElement(teamsnap_ui_1.PanelHeader, { title: "Member Info" }),
                React.createElement(teamsnap_ui_1.PanelBody, null,
                    React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "Panel-cell--header u-size3of12 u-flex" },
                            React.createElement("h4", null, "First Name")),
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size9of12" },
                            React.createElement(CreateElement, { inputRef: register({
                                    required: "You must enter a first name.",
                                }), useHookResponse: memberForm, type: "text", field: "firstName", label: "Organization Name", labelHidden: true, placeholder: "first name" }))),
                    React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "Panel-cell--header u-size3of12 u-flex" },
                            React.createElement("h4", null, "Last Name")),
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size9of12" },
                            React.createElement(CreateElement, { inputRef: register({
                                    required: "You must enter a last name.",
                                }), useHookResponse: memberForm, type: "text", field: "lastName", label: "Organization Name", labelHidden: true, placeholder: "Last name" }))),
                    React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "Panel-cell--header u-size3of12 u-flex" },
                            React.createElement("h4", null, "Birthday")),
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size9of12" },
                            React.createElement(CreateElement
                            // inputRef={register({
                            //   required: "You must enter a birthdate.",
                            // })}
                            , { 
                                // inputRef={register({
                                //   required: "You must enter a birthdate.",
                                // })}
                                useHookResponse: memberForm, type: "date", field: "birthdate", label: "This should be a date selector", labelHidden: true, dateProps: { maxDate: new Date() } }))),
                    React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "Panel-cell--header u-size3of12 u-flex" },
                            React.createElement("h4", null, "Gender")),
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size9of12" },
                            React.createElement(CreateElement, { useHookResponse: memberForm, inputRef: register({
                                    required: false,
                                }), type: "select", field: "gender", placeholder: "Gender", options: [
                                    { value: "", text: "No Selection" },
                                    { value: "Male", text: "Male" },
                                    { value: "Female", text: "Female" }
                                ], label: React.createElement("div", null,
                                    "Country",
                                    React.createElement("div", { className: "u-textNormal u-fontSizeSm" }, "Determines default currency for payments")) })))),
                React.createElement(teamsnap_ui_1.PanelFooter, { mods: "u-textLeft" },
                    React.createElement("div", { className: "button-list" },
                        React.createElement(teamsnap_ui_1.Button, { isDisabled: isSubmitting, color: "primary", icon: isSubmitting ? null : "check", type: "submit" },
                            isSubmitting && React.createElement(teamsnap_ui_1.Loader, { type: "spin", style: { width: "13px", height: "13px" } }),
                            "Save")))))));
};
exports.default = MemberEditForm;
//# sourceMappingURL=member-edit-form.js.map